// Sub-agent attribution (#20423 WS6). Pure functions — no React, no
// fetching — so the attribution math is unit-testable in isolation.
//
// This feeds the contributor strip: the distinct set of sub-agents that
// contributed to a response. (The inline section-banner placement math that
// used to live alongside it shipped disabled and was removed — see git
// history for computeSubAgentSections / rehypeSubAgentBanners if the
// offset-based rework picks it back up.)

import type { AssistantResponseSources } from "../types/provenance";

/**
 * Distinct non-primary agents that contributed to this response: any searched
 * query run by a sub-agent, or any source retrieval-event ref carrying an
 * agent. First-seen order is preserved.
 */
export const collectContributingAgents = (
  provenance: AssistantResponseSources | null | undefined,
): string[] => {
  if (!provenance) return [];
  const agents: string[] = [];
  const seen = new Set<string>();
  const add = (agent: string | null | undefined) => {
    if (agent && !seen.has(agent)) {
      seen.add(agent);
      agents.push(agent);
    }
  };
  for (const entry of provenance.searched ?? []) add(entry.agent);
  const sources = [
    ...(provenance.assistant_response_sources ?? []),
    ...(provenance.read_sources ?? []),
  ];
  for (const source of sources) {
    for (const ref of source.retrieval_events ?? []) add(ref.agent);
  }
  return agents;
};
